import React from 'react';
import { FiCornerUpRight, FiTrash2, FiMoreHorizontal } from 'react-icons/fi';
import { LuReply, LuReplyAll, LuForward } from 'react-icons/lu';

const formatFullDate = (dateStr) => {
  if (!dateStr) return '';
  try {
    return new Date(dateStr).toLocaleString([], {
      month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit',
    });
  } catch { return dateStr; }
};

const getInitials = (name = '') => {
  const parts = name.trim().split(' ');
  return parts.length >= 2
    ? (parts[0][0] + parts[1][0]).toUpperCase()
    : (name[0] || '?').toUpperCase();
};

const EmailReadingPane = ({ email, loading, onReply, onReplyAll, onForward, onDelete }) => {
  if (loading) {
    return (
      <div className="ec-reading-pane">
        <div className="ec-loading-pane">
          <div className="ec-spinner" />
          <span>Loading message...</span>
        </div>
      </div>
    );
  }

  if (!email) {
    return (
      <div className="ec-reading-pane">
        <div className="ec-reading-empty">
          <span className="ec-reading-empty-icon">✉</span>
          <span>Select an email to read</span>
        </div>
      </div>
    );
  }

  const senderName = email.from?.name || email.from?.email || 'Unknown';
  const senderEmail = email.from?.email || '';
  const initials = getInitials(senderName);

  return (
    <div className="ec-reading-pane">
      <div className="ec-reading-top">
        <div className="ec-reading-subject">{email.subject}</div>
        <div className="ec-reading-actions">
          <button className="ec-action-btn" title="Reply" onClick={() => onReply?.(email)}><LuReply size={15} /></button>
          <button className="ec-action-btn" title="Reply All" onClick={() => onReplyAll?.(email)}><LuReplyAll size={15} /></button>
          <button className="ec-action-btn" title="Forward" onClick={() => onForward?.(email)}><LuForward size={15} /></button>
          <button className="ec-action-btn" title="Delete" onClick={() => onDelete?.(email)}><FiTrash2 size={15} /></button>
          <button className="ec-action-btn" title="More"><FiMoreHorizontal size={15} /></button>
        </div>
      </div>

      <div className="ec-reading-meta">
        <div className="ec-avatar">{initials}</div>
        <div className="ec-sender-details">
          <div>
            <span className="ec-sender-full">{senderName}</span>
            {senderEmail && senderEmail !== senderName && (
              <span className="ec-sender-email-text">&lt;{senderEmail}&gt;</span>
            )}
          </div>
          {email.to && (
            <div className="ec-to-line">
              To: {email.to} · {formatFullDate(email.date)}
            </div>
          )}
        </div>
      </div>

      <div className="ec-reading-body">
        {email.html ? (
          <div
            dangerouslySetInnerHTML={{ __html: email.html }}
            style={{ maxWidth: '100%', overflow: 'hidden' }}
          />
        ) : (
          <pre>{email.plain || email.snippet || ''}</pre>
        )}
      </div>
    </div>
  );
};

export default EmailReadingPane;
